import { ComplianceFeatureFlagService } from '@services/feature-flags/compliance';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

import { Session } from '@services/session';

import { getCycle } from '@app/cycle/cycles';

import { ICompanyCycle } from '@app/dashboard/compliance/shared/interfaces';

@Injectable()
export class CanadianCycleGuard {
  constructor(
    private router: Router,
    private session: Session,
    private complianceFeatureFlagService: ComplianceFeatureFlagService,
  ) {}

  public canActivate(route: ActivatedRouteSnapshot): boolean {
    if (this.complianceFeatureFlagService.isComplianceCsaInsightsSkipCanadianCycleCheckEnabled()) return true;

    const config: { allowed: boolean; redirectTo: string } = route.data.canadianCycleGuard;

    const companyCycle: ICompanyCycle = getCycle(this.session.getCompanyProperty('cycle'));
    const isCanadianCycle = !!companyCycle && companyCycle.isCanadian;

    if (isCanadianCycle === config.allowed) return true;
    this.router.navigate([config.redirectTo || '']);
    return false;
  }
}
